import { AdSearchLink } from "@/components/ads/AdSearchLink";
import { RecentSearches } from "../RecentSearches";
import { TrendingTags } from "../TrendingTags";
import { useHistoryVisible } from "./hooks/useHistoryVisible";
import "./InitialSearchView.scss";

export const InitialSearchView = () => {
  const { handleSearchHistory, hasSearchHistory } = useHistoryVisible();

  return (
    <div className={`initialSearchView ${hasSearchHistory ? "hasHistory" : ""}`}>
      <RecentSearches handleSearchHistory={handleSearchHistory} />
      <TrendingTags />
      <AdSearchLink />
    </div>
  );
};
